//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            current: 0,
            testimonies: [],
            count: 0,
            interval: null,
        };
    },

    methods: {
        handleSlide( index ) {
            index = index - 1;

            this.current = index;

            this.$refs.wrapper.style.transform = 'translateX(' + ( ( 100 / this.count ) * index ) * -1 + '%)';

            this.autoSlide();
        },

        autoSlide() {
            if ( this.count > 1 ) {
                clearInterval( this.interval );

                this.interval = setInterval( () => {
                    if ( this.current + 2 > this.count ) {
                        this.current = -1;
                    }

                    this.handleSlide( this.current + 2 );
                }, 10000 );
            }
        }
    },

    mounted() {
        this.testimonies = this.$el.querySelectorAll('.flex-testimonial');
        this.count = this.testimonies.length;
        this.$refs.wrapper.style.width = 100 * this.count + '%';

        this.autoSlide();
    }
}
